import { render, staticRenderFns } from "./PricelistsList.vue?vue&type=template&id=878af924"
import script from "./PricelistsList.vue?vue&type=script&lang=js"
export * from "./PricelistsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports